export const env = {
  NODE_ENV: process.env.NODE_ENV,
  EXPO_PUBLIC_PRAYER_SPACE_V2_NEW_USERS_PERCENT: process.env.EXPO_PUBLIC_PRAYER_SPACE_V2_NEW_USERS_PERCENT || '',
  EXPO_PUBLIC_PRAYER_SPACE_V2_EXISTING_USERS_PERCENT:
    process.env.EXPO_PUBLIC_PRAYER_SPACE_V2_EXISTING_USERS_PERCENT || '',
  EXPO_PUBLIC_PRAYER_SPACE_V2_RELEASE_DATE: process.env.EXPO_PUBLIC_PRAYER_SPACE_V2_RELEASE_DATE || '',
  EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V2: process.env.EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V2 || '',
  EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V3: process.env.EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V3 || '',
  EXPO_PUBLIC_CONF_KEY_GOOGLE_SIGNIN_IOS_CLIENT_ID: process.env.EXPO_PUBLIC_CONF_KEY_GOOGLE_SIGNIN_IOS_CLIENT_ID || '',
  EXPO_PUBLIC_FILES_URL: process.env.EXPO_PUBLIC_FILES_URL || '',
  EXPO_PUBLIC_BLOCK_BANNER: process.env.EXPO_PUBLIC_BLOCK_BANNER || false,
  EXPO_PUBLIC_WEB_BASE_URL: process.env.EXPO_PUBLIC_WEB_BASE_URL,
  SENTRY_HMAC_KEY: process.env.EXPO_PUBLIC_SENTRY_HMAC_KEY || '',
  SENTRY_HMAC_IV: process.env.EXPO_PUBLIC_SENTRY_HMAC_IV || '',
  EXPO_PUBLIC_APP_VARIANT: process.env.EXPO_PUBLIC_APP_VARIANT || 'dev',
  NPM_PACKAGE_VERSION: process.env.npm_package_version,
  EXPO_PUBLIC_LEGACY_COMPATIBILITY: String(process.env.EXPO_PUBLIC_LEGACY_COMPATIBILITY) === 'true',
  EXPO_PUBLIC_LEGACY_BASE_URL: process.env.EXPO_PUBLIC_LEGACY_BASE_URL,
  EXPO_PUBLIC_APP_BASE_URL: process.env.EXPO_PUBLIC_APP_BASE_URL,
  EXPO_PUBLIC_CONF_KEY_GTM: process.env.EXPO_PUBLIC_CONF_KEY_GTM,
  EXPO_PUBLIC_NOTIFICATIONS_POLLING_INTERVAL: Number.isNaN(
    parseInt(process.env.EXPO_PUBLIC_NOTIFICATIONS_POLLING_INTERVAL || '', 10),
  )
    ? undefined
    : parseInt(process.env.EXPO_PUBLIC_NOTIFICATIONS_POLLING_INTERVAL || '', 10),
  EXPO_PUBLIC_VIRTUS_FRATERNITY_LEAD_URL: process.env.EXPO_PUBLIC_VIRTUS_FRATERNITY_LEAD_URL || '',
}
